module.exports = __webpack_public_path__ + "static/media/icon-chevron-up.90f47098.svg";